import { Divider } from "antd";
import { DividerProps } from "./type";

function AntDivider(props: DividerProps) {
  return <Divider {...props} />;
}

export { AntDivider as Divider };
